export const topMenuItemClassName = "hover:bg-alpha-high-97 menu-open";
